import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
//import { TranslateService } from '@ngx-translate/core';
import { IAddress } from 'src/app/shared/services/address.service';
import { CreditCardService } from '../../services/credit-card.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { ICreditCardForm } from 'src/app/shared/forms/credit-card-form/credit-card-form.component';
import { AuthService } from 'src/app/auth/services/auth.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-add-credit-card-modal',
    templateUrl: './add-credit-card-modal.component.html',
    styleUrls: ['./add-credit-card-modal.component.scss'],
    standalone: false
})
export class AddCreditCardModalComponent implements OnInit {
  title: string = 'Nav.AddCreditCard';

  @Input() storeId: string;

  creditCard: ICreditCardForm;
  billingAddress: IAddress;

  get emptyAddressPlaceHolder() {
    return this.translationService.translate('CreditCard.BillingAddress');
  }

  constructor(
    private modalCtrl: ModalController,
    //private translate: TranslateService,
    private translationService: TranslationService,
    private loader: LoaderService,
    private creditCardService: CreditCardService,
    private auth: AuthService,
    public setting: SettingService,
    private alert: AlertService) { }

  ngOnInit() {}

  onCreditCardChange(creditCard: ICreditCardForm) {
    this.creditCard = creditCard;
  }

  onBillingAddressChanged(address: IAddress) {
    this.billingAddress = address;
    this.billingAddress.country = "CA";
  }

  async addCardClicked() {
    const loader = await this.loader.create();
    await loader.present();

    let cvn = 0;
    //Now that the cvc input is a password field, must change the input value from string to number if it is a valid number. If not, 
      //the server will reject the cvc number not being able to convert it to int
    if (!isNaN(this.creditCard.cvc)) {
        cvn = Number(this.creditCard.cvc);
    }

    this.creditCardService.saveCard({
      address: this.billingAddress,
      cardHolderName: this.creditCard.fullName,
      cardNumber: this.creditCard.number,
      cvn: cvn,
      expirationMonth: this.creditCard.expirationMonth,
      expirationYear: this.creditCard.expirationYear,
      paymentCardTypeId: this.creditCard.typeId,
      storeId: this.storeId,
    })
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(async (result) => {
        if (result == null) {
          await this.alert.showTranslate('CreditCard.InvalidCard');
          return;
        }

        this.modalCtrl.dismiss(result);
      },
      (error) => {
      });
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }
}
